import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Analytics Integration
 * - Google Analytics 4 (GA4): G-KRHJZPZD77
 * - Plausible Analytics (privacy-first): custom script
 */
export default function Analytics() {
  const location = useLocation();
  const ga4Id = process.env.REACT_APP_GA4_ID;

  // Load GA4 script once
  useEffect(() => {
    if (!ga4Id) return;
    if (document.querySelector(`script[src*="googletagmanager.com/gtag"]`)) return;
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${ga4Id}`;
    script.async = true;
    document.head.appendChild(script);
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', ga4Id, { send_page_view: false });
  }, [ga4Id]);

  // Load Plausible custom script once
  useEffect(() => {
    if (document.querySelector(`script[src*="plausible.io"]`)) return;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://plausible.io/js/pa-IeSfWYYabwId4cXJZWNna.js';
    document.head.appendChild(script);
    // Init plausible
    window.plausible = window.plausible || function() {
      (window.plausible.q = window.plausible.q || []).push(arguments);
    };
    window.plausible.init = window.plausible.init || function(i) {
      window.plausible.o = i || {};
    };
    window.plausible.init();
  }, []);

  // Track page views on route change
  useEffect(() => {
    if (ga4Id && window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_title: document.title,
      });
    }
  }, [location, ga4Id]);

  return null;
}

// Custom event tracking utility
export function trackEvent(eventName, params = {}) {
  if (window.gtag) {
    window.gtag('event', eventName, params);
  }
  if (window.plausible) {
    window.plausible(eventName, { props: params });
  }
}
